/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _, { cloneDeep } from 'lodash';
import QuickReportsControls from '../components/QuickReports/QuickReportsControls';
import QuickReportsEditor from './QuickReportsEditor';
import QuickReportsViewer from './QuickReportsViewer';
import QuickReportToolPalate from '../components/QuickReports/QuickReportToolPalate';
import Modal from '../components/common/Modal/Modal';
import TitleValidationModal from '../components/crosstab/FunctionBox/TitleValidationModal';
import * as quickReportsActions from '../actions/quickReportsActions';
import * as crosstabActions from '../actions/crosstabActions';
import * as preferenceActions from '../actions/preferencesActions';
import * as studyActions from '../actions/studyActions';
import { saveTrackingData, storeUnsavedData } from '../util/trackerUtils';
import WarningIcon from './WarningIcon';
import {
  PAGE_VISIT_QUICKREPORTS, QUICKREPORTS_CONSTANT,
  PREFERENCE_QUICKREPORTS,
  PREFERENCE_STUDY,
  PREFERENCE_STUDY_WEIGHTING,
  QUICKREPORTS_FEATUREID,
  FLEX_STUDY_TAG,
  SIMMONS_CONNECT_STUDY_STI,
  SIMMONS_CONNECT_PLUS_STUDY_STI,
} from '../constants';
import CommonStudySelector from '../components/common/CommonStudySelector';
import enlargeIcon from '../images/enlarge-icon_48-67-93.png';
import enlargeHoverIcon from '../images/enlarge-icon_brown.png';
import basesDisabledIcon from '../images/bases_icon_disabled.png';
import basesHoverIcon from '../images/bases-small-icon.png';
import basesIcon from '../images/bases-small-icon_blue.png';
import targetDisabledIcon from '../images/target-icon_grey.png';
import targetIcon from '../images/target-icon_blue.png';
import targetHoverIcon from '../images/target-icon_red.png';
import runDisabledIcon from '../images/run_report_icon_disabled.png';
import runIcon from '../images/run_report_icon_normal.png';
import runHoverIcon from '../images/run_report_icon_hover.png';
import { GEOGRAPHY_BASES } from '../actions/actionTypes';
import { setModuleDataOnSave } from '../util/preferenceUtils';
import { toastWarning } from '../util/toastUtils';
import SmartSearch from '../components/common/SmartSearch/SmartSearch';
import { isFeaturePresent, filterStudies, getStudyFromStudies, filterStudyList } from '../util/CommonUtils';
import { REPORT_TYPES, REPORT_TYPES_MAPPED } from '../util/QuickReportsUtils';
import {
  QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED,
  QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED,
  QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED,
  QR_SMA_DISABLED_STUDIES,
  QR_TS_DISABLED_STUDIES,
  MRI_CONNECY_STUDY_STI,
} from '../actions/urlTypes';
import GenericButton from '../components/common/GenericButton';

const quickReportWarningModalStyle = {
  width: '25%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

const modalStyle = {
  width: '30%',
  top: '8%',
  left: '36%',
};

class QuickReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quickReportsWeightChanged: false,
      showViewerDisplayType: false,
      // messageBox: false,
      defaultStudy: props.quickReportsStudy ? props.quickReportsStudy : {},
      studies: this.props.studies ? filterStudies(this.props.studies, FLEX_STUDY_TAG) : [],
      showWeightType: true,
      hideWeightType: false,
      baseBtnDisabled: true,
      targetBtnDisabled: true,
      // runBtnDisabled: true,
      isTagInputExpanded: true,
      hasFeature: false,
      hasQuickReportsStudies: props.hasQuickReportsStudies === undefined ?
      true : props.hasQuickReportsStudies,
    };
    this.quickReportControls = React.createRef();
    this.updatedSmartSearch = React.createRef();
    this.quickReportWarningModal = React.createRef();
  }

  UNSAFE_componentWillMount() {
    const { modulePermissions } = this.props;
    let hasFeature = false;
    if (modulePermissions.length > 0) {
      hasFeature = isFeaturePresent(QUICKREPORTS_FEATUREID, modulePermissions);
    }

    this.setState({ hasFeature });
    if (this.checkQuickReportAccess()) {
      this.props.quickReportsActions.selectReport(REPORT_TYPES[0]);
    }
  }

  componentDidMount() {
    if (this.props.loginResponse !== undefined) {
      this.callSaveTrackerFn({ action: PAGE_VISIT_QUICKREPORTS });
      this.props.preferenceActions.setLastLocation({
        mainMenu: 'Essentials',
        mainModule: 'QuickReports',
      });
    }
    // this.handleWeightType();
    window.addEventListener('beforeunload', this.handleLeavePage);
    if (this.props.latestStudies
      && this.props.userPreferences && this.props.userPreferences._qr
      && this.props.userPreferences._qr._aus
      && Object.keys(this.props.latestStudies).length > 0
      && this.props.userPreferences._qr._ds !== -1
      && this.props.latestStudies._qr.productNo !== this.props.userPreferences._qr._ds) {
      const selectedStudy = getStudyFromStudies(
        filterStudyList(this.props.studies, QUICKREPORTS_FEATUREID),
        this.props.latestStudies._qr.productNo);
      this.props.studyActions.updateModuleStudy(QUICKREPORTS_CONSTANT, selectedStudy);
      const userPreferences = _.cloneDeep(this.props.userPreferences);
      userPreferences._qr._ds = selectedStudy.pn;
      this.saveUserPreference(userPreferences, true);
      this.showNewStudyToastMessage(this.props.quickReportsStudy, selectedStudy);
    }
    sessionStorage.removeItem('subModule');
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.hasQuickReportsStudies !== nextProps.hasQuickReportsStudies) {
      this.setState({ hasQuickReportsStudies: nextProps.hasQuickReportsStudies });
    }

    if (nextProps.studies && nextProps.studies !== this.props.studies) {
      this.setState(() => ({ studies: nextProps.studies }));
    }
    // arr = arr.filter(item => !forDeletion.includes(item))
    let oldTargetData = cloneDeep(this.props.TargetDataGrid);
    let newTargetData = cloneDeep(nextProps.TargetDataGrid);
    let oldBaseData = cloneDeep(this.props.BaseDataGrid);
    let newBaseData = cloneDeep(nextProps.BaseDataGrid);
    if (this.props.TargetDataGrid && oldTargetData.length > 0) {
      oldTargetData = this.formatGridData(oldTargetData);
    }
    if(nextProps.TargetDataGrid && newTargetData.length > 0) {
      newTargetData = this.formatGridData(newTargetData);
    }
    if (this.props.BaseDataGrid && oldBaseData.length > 0) {
      oldBaseData = this.formatGridData(oldBaseData);
    }
    if(nextProps.BaseDataGrid && newBaseData.length > 0) {
      newBaseData = this.formatGridData(newBaseData);
    }

   if (!_.isEqual(newTargetData, oldTargetData) || 
   !_.isEqual(newBaseData, oldBaseData) ||
   (nextProps.quickReportsStudy && this.props.quickReportsStudy &&
     !_.isEqual(nextProps.quickReportsStudy.pn, this.props.quickReportsStudy.pn)))
     {
      if (
        nextProps.selectedReport &&
        nextProps.TargetDataGrid &&
        nextProps.TargetDataGrid.length > 0 &&
        (this.props.TargetDataGrid &&
        this.props.TargetDataGrid.length !== 0)
      ) {
        this.quickReportWarningModal.current.show();
      } else {
        this.onMenuChanged(false);
      }
    }

    if (nextProps.latestStudies
      && nextProps.userPreferences && nextProps.userPreferences._qr
      && nextProps.userPreferences._qr._aus
      && this.props.latestStudies !== nextProps.latestStudies
      && Object.keys(nextProps.latestStudies).length > 0
      && nextProps.userPreferences._qr._ds !== -1
      && nextProps.latestStudies._qr.productNo !== nextProps.userPreferences._qr._ds) {
      const selectedStudy = getStudyFromStudies(
        filterStudyList(this.props.studies, QUICKREPORTS_FEATUREID),
        nextProps.latestStudies._qr.productNo
      );
      this.props.studyActions.updateModuleStudy(QUICKREPORTS_CONSTANT, selectedStudy);
      const userPreferences = _.cloneDeep(nextProps.userPreferences);
      this.showNewStudyToastMessage(nextProps.quickReportsStudy, selectedStudy);
      userPreferences._qr._ds = selectedStudy.pn;
      this.saveUserPreference(userPreferences, true);
    }

    if (nextProps.userPreferences && nextProps.quickReportsStudy
      && this.props.studies && nextProps.userPreferences[PREFERENCE_QUICKREPORTS]
      && ((nextProps.quickReportsStudy.pn !==
        nextProps.userPreferences[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY]) ||
        (nextProps.quickReportsStudy.wt !==
          nextProps.userPreferences[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY_WEIGHTING]))
      && this.props.preferenceFlags[QUICKREPORTS_CONSTANT]) {
      let selectedStudy;
      const updatedWeightType = nextProps.userPreferences[PREFERENCE_QUICKREPORTS]
        [PREFERENCE_STUDY_WEIGHTING] === 'Population' ? 1 : 2;
      if (nextProps.userPreferences[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY] !== -1) {
        selectedStudy = getStudyFromStudies(
          filterStudyList(this.props.studies, QUICKREPORTS_FEATUREID),
          nextProps.userPreferences[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY]
        );
      } else {
        selectedStudy = this.props.studies[0].sl[0];
      }
      const hideWeightType = this.props.weightTypeStudies && this.props.weightTypeStudies.some(el => {
        return el.pn === selectedStudy.pn;
      });
      this.setState(() => ({ hideWeightType }));
      selectedStudy = {
        ...selectedStudy,
        wt: updatedWeightType,
      };
      if (selectedStudy !== undefined) {
        this.props.studyActions.updateModuleStudy(QUICKREPORTS_CONSTANT, selectedStudy);
        const updatedWeightTypeObj = (typeof (nextProps.userPreferences[PREFERENCE_QUICKREPORTS]
          [PREFERENCE_STUDY_WEIGHTING]) === 'string' || nextProps.userPreferences[PREFERENCE_QUICKREPORTS]
            [PREFERENCE_STUDY_WEIGHTING].wt === undefined) ? selectedStudy.cw[0] :
            nextProps.userPreferences[PREFERENCE_QUICKREPORTS][PREFERENCE_STUDY_WEIGHTING];
        this.props.studyActions.updateWeightType(QUICKREPORTS_CONSTANT, updatedWeightTypeObj);
      }
      this.props.preferenceActions.setPreferenceFlag(QUICKREPORTS_CONSTANT, false);
    }
    if (this.props.quickReportsStudy !== nextProps.quickReportsStudy) {
      this.setState(() => ({ defaultStudy: nextProps.quickReportsStudy }));
      if (nextProps.studies && nextProps.studies !== this.props.studies) {
        this.setState(() => ({ studies: filterStudies(nextProps.studies, FLEX_STUDY_TAG) }));
      }
      const sampleWeightedParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: nextProps.quickReportsStudy.pn,
        weightType: nextProps.quickreportsWeightTypes.wt,
        divisor: nextProps.quickreportsWeightTypes.dv,
        gridData: [],
      };
      if (this.props.TargetDataGrid && this.props.TargetDataGrid.length > 0) {
        const targetParams = {
          ...sampleWeightedParams,
          sourceGrid: 'TargetDataGrid',
          targetGrid: 'TargetDataGrid',
          expressionList: [this.props.TargetDataGrid[0].keyword],
          selectedNames: [this.props.TargetDataGrid[0].title],
          originalNames: [this.props.TargetDataGrid[0].originalTitle],
        };
        this.getSampleWeighted(targetParams, false);
      }

      if (this.props.BaseDataGrid && this.props.BaseDataGrid.length > 0) {
        const baseParams = {
          ...sampleWeightedParams,
          sourceGrid: 'BaseDataGrid',
          targetGrid: 'BaseDataGrid',
          expressionList: [this.props.BaseDataGrid[0].keyword],
          selectedNames: [this.props.BaseDataGrid[0].title],
          originalNames: [this.props.BaseDataGrid[0].originalTitle],
        };
        this.getSampleWeighted(baseParams, false);
      }
      if (this.checkQuickReportAccess(nextProps.quickReportsStudy)) {
        if (!this.props.selectedReport) {
          this.props.quickReportsActions.selectReport(REPORT_TYPES[0]);
        }
      } else {
        this.props.quickReportsActions.clearAllReport();
      }
    }

    if (
      this.props.reportResult !== nextProps.reportResult &&
      nextProps.reportResult
    ) {
      this.onMenuChanged(true);
    }
    if (nextProps.kpiInfo !== this.props.kpiInfo) {
      if (nextProps.kpiInfo && nextProps.kpiInfo.intab) {
        this.setState({ targetBtnDisabled: false, baseBtnDisabled: false });
      } else {
        this.setState({ targetBtnDisabled: true, baseBtnDisabled: true });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  onMenuChanged = showViewerDisplayType => {
    this.setState({ showViewerDisplayType });
    if (!this.props.selectedReport && this.checkQuickReportAccess()) {
      this.props.quickReportsActions.selectReport(REPORT_TYPES[0]);
    }
  }

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    selectedReport: this.props.selectedReport,
    BaseDataGrid: this.props.BaseDataGrid,
    TargetDataGrid: this.props.TargetDataGrid,
    RecycleElements: this.props.recycleElements,
  });

  handleWeightType = () => {
    let hideWeightType;
    if (this.props.quickReportsStudy) {
      hideWeightType = this.props.weightTypeStudies.some(el => {
        return el.pn === this.props.quickReportsStudy.pn;
      });
      this.setState(() => ({ hideWeightType }));
    }
  }

  handleLeavePage = () => {
    this.props.storeUnsavedData(
      this.props.currentState,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId
    );
  }

  callSaveTrackerFn = ({ action, subModule = undefined }) => {
    const productNo = this.props.quickReportsStudy !== undefined ?
      this.props.quickReportsStudy.pn : undefined;
    if (subModule) {
      sessionStorage.setItem('subModule', subModule);
    }
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName: 'QuickReports',
      subModule,
      action,
    });
  }

  onQuickReportClear = () => {
    this.props.quickReportsActions.clearAllReport();
    if (this.checkQuickReportAccess()) {
      this.props.quickReportsActions.selectReport(REPORT_TYPES[0]);
    }
  }

  formatGridData = (data) => {
    const newTargetData = 
    {
      keyword: data[0].keyword,
      originalTitle: data[0].originalTitle,
      title: data[0].title,
      tooltip: data[0].tooltip,
  }
  return newTargetData;
  }

  setSelectedStudy = (selectedStudy, updatedWeightType) => {
    const updatedStudy = {
      ...selectedStudy,
      wt: 1,   // updating weight type to population by default.
    };
    if (updatedStudy.pn !== this.props.quickReportsStudy.pn) {
      this.props.studyActions.updateModuleStudy(QUICKREPORTS_CONSTANT, updatedStudy, updatedWeightType);
      // const hideWeightType = this.props.weightTypeStudies.some(el => {
      //   return el.pn === updatedStudy.pn;
      // });
      // this.setState(() => ({ hideWeightType }));
    }
  }

  showNewStudyToastMessage = (beforeUpdateStudy, afterUpdateStudy) => {
    toastWarning(
      <span style={{ color: 'black', width: '400px' }}>
        Your default study has been updated from
        <span style={{ fontWeight: 'bold' }}> {beforeUpdateStudy.sd} </span>
        to <span style={{ fontWeight: 'bold' }}> {afterUpdateStudy.sd}. </span>
        This change is occuring because you have previously set your preferences to
         automatically update your study on start-up when a
         new version of the study type is released.
      </span>);
  }

  saveUserPreference = (preferences, moduleUpdateFlag) => {
    const clonedPreferences = _.clone(preferences);
    this.props.preferenceActions.saveUserPreferences(
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      preferences
    ).then(response => {
      if (response && moduleUpdateFlag) {
        this.props.setModuleDataOnSave(clonedPreferences);
      }
    });
  }

  handleWeightType = () => {
    let hideWeightType;
    if (this.props.quickReportsStudy) {
      hideWeightType = this.props.weightTypeStudies.some(el => {
        return el.pn === this.props.quickReportsStudy.pn;
      });
      this.setState(() => ({ hideWeightType }));
    }
  }

  handleChangeWeightType = weightType => {
    const updatedStudyItem = {
      ...this.state.defaultStudy,
      wt: weightType,
    };
    this.props.studyActions.updateModuleStudy(QUICKREPORTS_CONSTANT, updatedStudyItem);
  }

  handleMove = targetGrid => {
    this.props.quickReportsActions.setQuickReportRunFlag(true);
    const {
      expressionFormed,
      objectsAdded,
      selectedCategoryID,
      tags,
    } = this.updatedSmartSearch.current.state;
    this.updatedSmartSearch.current.handleSelectedIndexState();
    const objSmartSearchArray = [
      { expressionFormed, objectsAdded, selectedCategoryID, tags },
    ];
    const expression = expressionFormed.join(' ');
    if (this.props.quickReportsStudy && expressionFormed.length > 0) {
      const selectedNames = [
        objectsAdded.reduce(
          (acc, { shortText }) => `${acc} ${shortText}`,
          '',
        ),
      ];
      const geographyBase = GEOGRAPHY_BASES.some(base =>
        expression.includes(base),
      );
      let recTypes = [];
      if (geographyBase) {
        recTypes.push('G');
      } else {
        recTypes = [
          objectsAdded.reduce(
            (acc, { recType }) => `${recType}`,
            '',
          ),
        ];
      }
      const gridData = this.getGridData();
      const sampleWeightedParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: this.props.quickReportsStudy.pn,
        weightType: this.props.quickreportsWeightTypes.wt,
        divisor: this.props.quickreportsWeightTypes.dv,
        gridData:
          gridData[targetGrid] &&
            (targetGrid !== 'TargetDataGrid' && targetGrid !== 'BaseDataGrid')
            ? gridData[targetGrid]
            : [],
        expressionList: [expressionFormed.join(' ')],
        originalNames: selectedNames,
        selectedNames,
        targetGrid,
        recTypes,
        objSmartSearchArray,
      };
      this.getSampleWeighted(sampleWeightedParams, false);
      this.updatedSmartSearch.current.resetAll();
      this.setState({ targetBtnDisabled: true, baseBtnDisabled: true });
    }
  };

  getSampleWeighted = (sampleWeightedParams, weightChanged) => {
    const quickReportsWeightChanged = weightChanged || false;
    this.setState({ quickReportsWeightChanged }, () => {
      this.props.quickReportsActions.getSampleWeighted(sampleWeightedParams);
    });
  }

  handleShowValidatePopup = () => {
    this.VariablesNotDetectedModal.show();
  }

  renderQuickReportsViewer = runReport => {
    const runQuickReport = runReport.current
      ? runReport.current.runReport
      : null;
    if (this.state.showViewerDisplayType) {
      return (
        <QuickReportsViewer
          toggleQuickReportView={this.onMenuChanged}
          quickReportsStudy={this.props.quickReportsStudy}
          quickReportsClear={this.onQuickReportClear}
          runReport={runQuickReport}
          trackerFn={this.callSaveTrackerFn}
          showValidate={this.handleShowValidatePopup}
          quickReportRunFlag={this.props.quickReportRunFlag}
        />
      );
    }
    return (
      <QuickReportsEditor
        quickReportsStudy={this.props.quickReportsStudy}
        getSampleWeighted={this.getSampleWeighted}
        gridData={this.getGridData()}
        fetchKPI={this.props.crosstabActions.fetchKPI}
      />
    );
  };

  getSampleWeightedQuickReports = weightList => {
    const { loginResponse, activeAccountId, quickReportsStudy, quickReports } = this.props;
    let sampleWeightedParams = {
      token: loginResponse.data.token,
      uid: loginResponse.data.uid,
      accountId: activeAccountId,
      productNo: quickReportsStudy.pn,
      weightType: weightList.wt,
      divisor: weightList.dv || 1000,
      weightChange: true,
    };

    if (quickReports.TargetDataGridData && quickReports.TargetDataGridData.length > 0) {
      const userStateData = this.generateGridData(quickReports, 'TargetDataGridData');
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'TargetDataGrid',
        targetGrid: 'TargetDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      this.getSampleWeighted(sampleWeightedParams, true);
    }

    if (quickReports.BaseDataGridData && quickReports.BaseDataGridData.length > 0) {
      const userStateData = this.generateGridData(quickReports, 'BaseDataGridData');
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BaseDataGrid',
        targetGrid: 'BaseDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      this.getSampleWeighted(sampleWeightedParams, true);
    }
  };

  handleRunReport = weightListdata => {
    this.quickReportControls.current.runReportFirstTime(weightListdata);
  }

  generateGridData = (gridData, gridItem) => {
    const data = {
      selectedKeywords: [],
      selectedNames: [],
      originalNames: [],
      recTypes: [],
      dataSmartSearch: [],
    };
    gridData[gridItem].forEach(item => {
      data.selectedKeywords.push(item.keyword);
      data.selectedNames.push(item.title);
      data.originalNames.push(item.originalTitle);
      data.recTypes.push(item.recType || item.rectype || item.type);
      data.dataSmartSearch.push(item.dataSmartSearch);
    });
    return data;
  };

  hideTitleValidationModalPopup = () => {
    this.props.quickReportsActions.setQuickReportRunFlag(true);
    this.quickReportWarningModal.current.hide();
  }

  checkQuickReportAccess(quickReportsStudy) {
    const _quickReportsstudy = quickReportsStudy || this.props.quickReportsStudy;
    const report = this.props.selectedReport ? this.props.selectedReport : REPORT_TYPES[0];

    let isSelectable = true;
    if (report.key === 'DEMOPROFILE'
      && _quickReportsstudy
      && _quickReportsstudy.sti
      && QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED
      .indexOf(_quickReportsstudy.sti) !== -1) {
        isSelectable = false;
    } else if (report.key === 'SEGMENTATION'
      && _quickReportsstudy
      && _quickReportsstudy.sti
      && QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED
      .indexOf(_quickReportsstudy.sti) !== -1) {
        isSelectable = false;
    } else if (report.key === 'MAP'
      && ((_quickReportsstudy
      && _quickReportsstudy.sti
      && QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED
      .indexOf(_quickReportsstudy.sti) !== -1) 
      || (_quickReportsstudy &&
        /local/gi.test( _quickReportsstudy.sd)))) {
        isSelectable = false;
    } else if (report.key === REPORT_TYPES_MAPPED.SMAP) {
      isSelectable = (_quickReportsstudy &&
        /connect/gi.test(_quickReportsstudy.sd) &&
        (_quickReportsstudy.sti === SIMMONS_CONNECT_STUDY_STI ||
          _quickReportsstudy.sti ===
            SIMMONS_CONNECT_PLUS_STUDY_STI)) || (_quickReportsstudy &&
              /connect/gi.test(_quickReportsstudy.sd) &&
              MRI_CONNECY_STUDY_STI.indexOf(_quickReportsstudy.sti) !== -1) &&
              !(QR_SMA_DISABLED_STUDIES.indexOf(_quickReportsstudy.st) !== -1);
    } else if (report.key === REPORT_TYPES_MAPPED.TIMESPENT) {
      isSelectable = (_quickReportsstudy &&
        /connect/gi.test(_quickReportsstudy.sd) &&
        (_quickReportsstudy.sti === SIMMONS_CONNECT_STUDY_STI ||
          _quickReportsstudy.sti ===
            SIMMONS_CONNECT_PLUS_STUDY_STI)) || (_quickReportsstudy &&
              /connect/gi.test(_quickReportsstudy.sd) &&
              MRI_CONNECY_STUDY_STI.indexOf(_quickReportsstudy.sti) !== -1) &&
              !(QR_TS_DISABLED_STUDIES.indexOf(_quickReportsstudy.st) !== -1);
    } else {
      isSelectable =
        (_quickReportsstudy &&
          /connect/gi.test(_quickReportsstudy.sd) &&
          (_quickReportsstudy.sti === SIMMONS_CONNECT_STUDY_STI ||
            _quickReportsstudy === SIMMONS_CONNECT_PLUS_STUDY_STI)) ||
        (_quickReportsstudy &&
          /connect/gi.test(_quickReportsstudy.sd) &&
           MRI_CONNECY_STUDY_STI.indexOf(_quickReportsstudy.sti) !== -1 &&
          report.key !== REPORT_TYPES_MAPPED.DIGITALACTIVITY &&
          report.key !== REPORT_TYPES_MAPPED.SIM) ||
        report.isForAllStudy;
    }

    return isSelectable;
  }

  render() {
    const { hasFeature } = this.state;
    if (!hasFeature) {
      return (
        <div className="no-study-message">
          <WarningIcon />
          <p>
            You do not currently have permissions to the Quick Reports application.
            Please contact your Account Manager to learn more about your access
          </p>
        </div>
      );
    }
    if (!this.state.hasQuickReportsStudies) {
      return (
        <div className="no-study-message">
          <WarningIcon />
          <p>
            You do not currently have studies to the Quick Reports application.
            Please contact your Account Manager to learn more about your studies.
          </p>
        </div>
      );
    }
    return (
      <div>
        <input type="checkbox" className="sidebar-left" id="sidebar-left-01" />
        <label className="sidebar-left" htmlFor="sidebar-left-01" />
        <QuickReportToolPalate
          trackerFn={this.callSaveTrackerFn}
          selectedReport={this.props.selectedReport}
        />
        <div
          className="width-80 portfolio-crosstab float-left"
          style={{
            overflowY: 'auto',
            height: 'calc(100vh - 57px)',
            overflowX: 'hidden',
          }}
        >
          <QuickReportsControls
            toggleQuickReportView={this.onMenuChanged}
            ref={this.quickReportControls}
            trackerFn={this.callSaveTrackerFn}
            quickReportsActions
          />
          <div className="smart-search-editor">
            <div className="appBreadcrumb">
              <div
                className="crosstab-study-selector"
              >
                <CommonStudySelector
                  studies={this.state.studies}
                  featureID={QUICKREPORTS_FEATUREID}
                  // defaultStudy={this.state.smartSearchStudy}
                  defaultStudy={this.state.defaultStudy}
                  dataOnScreen={this.checkSCTabHasData}
                  alertMsg="This selection will impact all of the Crosstab modules"
                  setMethod={this.setSelectedStudy}
                  resetMethod={click => (this.resetSelectedSCStudy = click)}
                  // label={'Source:'}
                  showWeightType={this.state.showWeightType}
                  handleChangeWeightType={this.handleChangeWeightType}
                  hideWeightType={this.state.hideWeightType}
                  menuName={QUICKREPORTS_CONSTANT}
                  selectedWeightType={this.props.quickreportsWeightTypes}
                  getSampleWeightedQuickReports={this.getSampleWeightedQuickReports}
                  runReport={this.handleRunReport}
                />
              </div>
              <div className="essential-breadcrumb">
                <span className="parent">Essentials / </span>Quick Reports
              </div>
            </div>
            <div className="large-12 quick-reports-wrapper">
              <SmartSearch
                selectedModule="quickReports"
                moduleStudy={this.props.quickReportsStudy}
                getSampleWeighted={
                  this.getSampleWeighted
                }
                fetchKPI={this.props.crosstabActions.fetchKPI}
                gridData={this.getGridData()}
                dataScreen="quickReport"
                ref={this.updatedSmartSearch}
                isTagInputExpanded={this.state.isTagInputExpanded}
              />
              <div className="move-to-wrapper quick-reports-smart-search">
                <div className="button-group">
                <button
                  type="button"
                  onBlur={() => {}}
                  onFocus={() => {}}
                  className="button square-button"
                  onMouseOver={this.mouseOver}
                  onMouseOut={this.mouseOut}
                  onClick={() =>
                    this.setState(prevState => ({
                      isTagInputExpanded: !prevState.isTagInputExpanded,
                    }))
                  }
                >
                  <div className="square">
                    {!this.state.isTagInputExpanded ? (
                      <img
                        src={enlargeIcon}
                        data-src={enlargeIcon}
                        data-hoversrc={enlargeHoverIcon}
                        alt="Expand Smart Search"
                        title="Expand Smart Search"
                      />
                    ) : (
                        <img
                          src={enlargeHoverIcon}
                          data-src={enlargeHoverIcon}
                          data-hoversrc={enlargeHoverIcon}
                          alt="Expand Smart Search"
                          title="Expand Smart Search"
                        />
                      )}
                    <span>EXPAND</span>
                  </div>
                </button>
                  {this.state.baseBtnDisabled ? (
                    <button type="button" className="button square-button" disabled>
                      <div className="square">
                        <img
                          src={basesDisabledIcon}
                          data-src={basesDisabledIcon}
                          data-hoversrc={basesDisabledIcon}
                          alt="Move to Base"
                          title="Move to base"
                        />
                        <span>BASES</span>
                      </div>
                    </button>
                  ) : (
                    <button
                      type="button"
                      onBlur={() => {}}
                      onFocus={() => {}}
                      className="button square-button"
                      onMouseOver={this.mouseOver}
                      onMouseOut={this.mouseOut}
                      onClick={() => this.handleMove('BaseDataGrid')}
                    >
                      <div className="square">
                        <img
                          src={basesIcon}
                          data-src={basesIcon}
                          data-hoversrc={basesHoverIcon}
                          alt="Move to Base"
                          title="Move to base"
                        />
                        <span>BASE</span>
                      </div>
                    </button>
                  )}
                  {this.state.targetBtnDisabled ? (
                    <button type="button" className="button square-button" disabled>
                      <div className="square">
                        <img
                          src={targetDisabledIcon}
                          data-src={targetDisabledIcon}
                          data-hoversrc={targetDisabledIcon}
                          alt="Move to target"
                          title="Move to target"
                        />
                        <span>TARGET</span>
                      </div>
                    </button>
                  ) : (
                    <button
                      type="button"
                      onBlur={() => {}}
                      onFocus={() => {}}
                      className="button square-button"
                      onMouseOver={this.mouseOver}
                      onMouseOut={this.mouseOut}
                      onClick={() => this.handleMove('TargetDataGrid')}
                    >
                      <div className="square">
                        <img
                          src={targetIcon}
                          data-src={targetIcon}
                          data-hoversrc={targetHoverIcon}
                          alt="Move to target"
                          title="Move to target"
                        />
                        <span>TARGET</span>
                      </div>
                    </button>
                  )}
                  {!(
                this.props.TargetDataGrid &&
                this.props.quickReportRunFlag &&
                this.props.TargetDataGrid.length > 0 &&
                this.props.selectedReport
              ) ? (
                  <button type="button" className="button square-button" disabled>
                    <div className="square">
                      <img
                        src={runDisabledIcon}
                        data-src={runDisabledIcon}
                        data-hoversrc={runDisabledIcon}
                        alt="Run Analysis"
                        title="Run Analysis"
                      />
                    </div>
                  </button>
                ) : (
                  <button
                    type="button"
                    onBlur={() => {}}
                    onFocus={() => {}}
                    className="button square-button"
                    onMouseOver={this.mouseOver}
                    onMouseOut={this.mouseOut}
                    onClick={() =>
                      this.quickReportControls
                        .current
                        .runReportFirstTime()
                    }
                  >
                    <div className="square">
                      <img
                        src={runIcon}
                        data-src={runIcon}
                        data-hoversrc={runHoverIcon}
                        alt="Run Analysis"
                        title="Run Analysis"
                      />
                    </div>
                  </button>
                )}
                </div>
              </div>
            </div>
          </div>
          {this.renderQuickReportsViewer(this.quickReportControls)}
        </div>
        <Modal
          title=""
          ref={this.quickReportWarningModal}
          dialogStyles={quickReportWarningModalStyle}
        >
          <div className="row expanded">
            <TitleValidationModal
              customMessage="You have selected either a new Base, Target or Study. Please click Run report again."
              handleParentHide={() => {this.hideTitleValidationModalPopup()}}
            />
          </div>
        </Modal>
        <Modal
          title="Variables Not Detected"
          ref={node => {
            this.VariablesNotDetectedModal = node;
            return this.VariablesNotDetectedModal;
          }}
          dialogStyles={modalStyle}
        >
          <p>
            There are one or more variables used in this Quick Report that are
            not available in the study you have selected. Please Choose another
            study and try again.
          </p>
          <div className="text-center">
            <GenericButton
              name="OK"
              onBtnClick={() => this.VariablesNotDetectedModal.hide()}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

QuickReports.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  BaseDataGrid: PropTypes.arrayOf(PropTypes.object),
  TargetDataGrid: PropTypes.arrayOf(PropTypes.object),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  quickReportsStudy: PropTypes.shape({
    pn: PropTypes.number,
    wt: PropTypes.number,
  }),
  reportResult: PropTypes.shape({}),
  quickReportsActions: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    clearAllReport: PropTypes.func,
    selectReport: PropTypes.func,
    runQuickReports: PropTypes.func,
  }),
  crosstabActions: PropTypes.shape({
    fetchKPI: PropTypes.func,
  }),
  kpiInfo: PropTypes.shape({
    intab: PropTypes.number,
  }),
  selectedReport: PropTypes.shape({
    key: PropTypes.string,
  }),
  currentState: PropTypes.shape({}),
  storeUnsavedData: PropTypes.func,
  preferenceActions: PropTypes.shape({
    setLastLocation: PropTypes.func,
    setPreferenceFlag: PropTypes.func,
    saveUserPreferences: PropTypes.func,
  }),
  latestStudies: PropTypes.shape({
    _qr: PropTypes.shape({
      productNo: PropTypes.number,
    }),
  }),
  studies: PropTypes.arrayOf(PropTypes.object),
  setModuleDataOnSave: PropTypes.func,
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
    updateWeightType: PropTypes.func,
  }),
  modulePermissions: PropTypes.instanceOf(Array),
  hasQuickReportsStudies: PropTypes.bool,
  quickreportsWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  quickReports: PropTypes.shape({
    BaseDataGrid: PropTypes.shape({}),
    TargetDataGrid: PropTypes.shape({}),
    TargetDataGridData: PropTypes.instanceOf(Array),
    BaseDataGridData: PropTypes.instanceOf(Array),
  }),
  userPreferences: PropTypes.shape({
    _qr: PropTypes.shape({
      _aus: PropTypes.bool,
      _ds: PropTypes.number,
      wt: PropTypes.number,
    }),
  }),
  preferenceFlags: PropTypes.shape({}),
  weightTypeStudies: PropTypes.instanceOf(Array),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    quickReportsStudy: state.study.quickReportsStudy,
    BaseDataGrid: state.quickReports.BaseDataGridData,
    TargetDataGrid: state.quickReports.TargetDataGridData,
    recycleElements: state.quickReports.RecycleGridData,
    reportResult: state.quickReports.reportResult,
    selectedReport: state.quickReports.selectedReport,
    kpiInfo: state.crosstab.kpiInfo,
    quickReports: state.quickReports,
    currentState: state,
    dataPointsAlreadyAdded: state.dataPointsAlreadyAdded,
    // weightTypeStudies: state.study.weightTypeStudies,
    studies: state.study.studies,
    userPreferences: state.preferences.userPreferences,
    preferenceFlags: state.preferences.preferenceFlags,
    crosstab: state.crosstab,
    sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
    latestStudies: state.study.latestStudies,
    modulePermissions: state.userDetail.permissions,
    hasQuickReportsStudies: state.study.hasQuickReportsStudies,
    quickreportsWeightTypes: state.study.quickreportsWeightTypes,
    quickReportsTarget: state.quickReports.TargetDataGridData,
    quickReportsBase: state.quickReports.BaseDataGridData,
    quickReportRunFlag: state.quickReports.quickReportRunFlag,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    storeUnsavedData: bindActionCreators(storeUnsavedData, dispatch),
    preferenceActions: bindActionCreators(preferenceActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    setModuleDataOnSave: bindActionCreators(setModuleDataOnSave, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(QuickReports);
